import generatePDF, { type Options } from 'react-to-pdf';
import { PDF_OPTIONS } from './constants';

export const PDF_EXPORT_ROOT_CLASS = 'is-pdf-export';

type TargetElementFinder = Parameters<typeof generatePDF>[0];

const resolveTarget = (targetRefOrFunction: TargetElementFinder): HTMLElement | null => {
    if (typeof targetRefOrFunction === 'function') {
        return targetRefOrFunction();
    }
    return targetRefOrFunction.current ?? null;
};

/** Captures an element as PDF with print-friendly table styling applied during snapshot. */
export async function generatePdfSnapshot(targetRefOrFunction: TargetElementFinder, customOptions?: Options) {
    const target = resolveTarget(targetRefOrFunction);
    if (!target) {
        return;
    }

    target.classList.add(PDF_EXPORT_ROOT_CLASS);
    try {
        return await generatePDF(() => target, {
            // PDF_OPTIONS.method is inferred as string; react-to-pdf wants the
            // 'save' | 'open' | 'build' literal union. Cast the shared preset (not
            // mutating the constant, which other report exporters also spread).
            ...(PDF_OPTIONS as Options),
            ...customOptions,
        });
    } finally {
        target.classList.remove(PDF_EXPORT_ROOT_CLASS);
    }
}
